<template>
    <!--    use attach attribute to display popup in fullscreen mode    -->
    <v-dialog :value="show" id="app-popup-observation" width="80%" @click:outside="$emit('cancel')" attach=".map-template-container">

        <v-card>
            <v-card-title>
            <!--  {{Math.ceil($store.state.mapPosition.x/5000)*5000 - 2500}}/{{Math.ceil($store.state.mapPosition.y/5000)*5000 - 2500}} -->
                <span class="headline">{{$t('observation.popupTitle') }} {{X}}/{{Y}}</span>
            </v-card-title>
            <v-card-text>

                <b>{{$t('observation.popupID') }}</b> {{ taxonId }} <br>
                <b>{{$t('observation.popupName') }}</b> {{ taxonName }} <br>
                <b>{{$t('observation.popupObservations') }} </b> {{$t('observation.popupTotal') }}
                {{observations.length}}

                <v-data-table id="app-table-popup-observation"
                              dense
                              :headers="headers"
                              :items="observations"
                              sort-by="date" sort-desc
                              :items-per-page="5"
                              item-key="observationArray.id"
                              class="elevation-1 mt-5"
                              :footer-props="{
                                    showFirstLastPage: true,
                                    firstIcon: 'mdi-arrow-collapse-left',
                                    lastIcon: 'mdi-arrow-collapse-right',
                                    prevIcon: 'mdi-minus',
                                    nextIcon: 'mdi-plus'
                                  }"
                />


            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn id="app-popup-observation-button" right text :title="$t('title.cancel')" @click="$emit('cancel')">{{
                    $t('general.close') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>

<script>


    export default {
        name: 'ObservationPopup',

        props: {
            headers: {type: Array},
            observations: {type: Array},
            show: {type: Boolean, default: false},
            X: {type: Number, default: 0},
            Y: {type: Number, default: 0},

        },

        computed: {
            taxonId() {
                return this.$store.state.taxonId
            },
            taxonName() {
                return this.$store.state.taxonName
            },

        },


    }
</script>

<style scoped lang="scss">
    @import '../../../global';

    #app-popup-observation {
        position: absolute !important;
    }

    /* set to nowrap to avoid shrinking of table headers, see also: https://github.com/vuetifyjs/vuetify/issues/10164*/
    #app-table-popup-observation {
        white-space: nowrap !important;
    }

    #app-popup-observation-button {
        color: $app-dark-red
    }


</style>